import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import viVN from 'antd/es/locale/vi_VN';
import moment from 'moment';
import 'moment/locale/vi';
import './css/bootstrap.min.css';
import './css/main.css';
import './css/main.scss';
import './css/chat.css';
import './css/chat-modern.css';
import './css/responsive.css';


import App from './App';
import * as serviceWorker from './serviceWorker';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'antd/dist/antd.css'; //theme antd

import 'emoji-mart/css/emoji-mart.css' // theme emoij

// Chromium may emit these non-fatal notifications while Ant Design tables,
// drawers and modals settle their layout. CRA treats them as runtime errors
// and opens the red overlay even though the application continues normally.
const RESIZE_OBSERVER_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.'
];

moment.locale('vi');

const vietnameseLocale = {
  ...viVN,
  DatePicker: {
    ...viVN.DatePicker,
    lang: {
      ...viVN.DatePicker.lang,
      dateFormat: 'DD/MM/YYYY',
      dateTimeFormat: 'HH:mm DD/MM/YYYY'
    }
  }
};

window.addEventListener('error', event => {
  if (RESIZE_OBSERVER_MESSAGES.includes(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

ReactDOM.render(
    <ConfigProvider locale={vietnameseLocale}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>,
     document.getElementById('root-chat')
   );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
